import Color from 'color';
import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { TextValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextValue';
import { ColorPickerButton } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPickerButton';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { useDetailCRUD } from 'hooks/detail/useDetailCRUD';
import { useContext, useEffect, useState } from 'react';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
    disableEditText?: boolean;
}

const TEXT_HALO_WIDTH = 1;
const TEXT_HALO_COLOR = {
    forLight: '#000',
    forDark: '#fff'
};

export const IconMarkerLabelSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const detailCRUD = useDetailCRUD(ctxEdit.map.worldMapId);

    const [storyTitle, setStoryTitle] = useState(null);

    function updateLabel(value: string) {
        ctxEdit.updateWorldMarkerData(props.marker.id, { text: value });
    }

    function updateColor(value: string) {
        ctxEdit.updateWorldMarkerData(props.marker.id, {
            textColor: value,
            textHaloWidth: TEXT_HALO_WIDTH,
            textHaloColor: Color(value).isLight()
                ? TEXT_HALO_COLOR.forLight
                : TEXT_HALO_COLOR.forDark
        });
    }

    useEffect(() => {
        if (props.marker?.storyIds?.length !== 1) {
            return;
        }
        const readStory = async () => {
            const story = await detailCRUD.readDetail(props.marker.storyIds[0]);
            if (story.data?.moment?.header?.title) {
                setStoryTitle(story.data.moment.header.title);
            }
        };
        readStory();
    }, [props.marker.storyIds?.length]);

    return (
        <S_IconMarkerLabelSection className={props.className}>
            <SidebarSection title={Localization.LABEL} icon={{ iconName: 'font' }} topBorder>
                <S_SidebarContent withTopPadding withHover>
                    <TextValue
                        value={props.marker.elementData.text}
                        disabled={props.disableEditText}
                        onChange={updateLabel}
                    />
                    <ColorPickerButton
                        value={props.marker.elementData.textColor}
                        onChange={updateColor}
                    />
                </S_SidebarContent>
                {!props.disableEditText && (
                    <S_SidebarContent>
                        <ActionButton
                            text={Localization.LOAD_FROM_DETAIL}
                            icon={{ iconName: 'bullseye-pointer' }}
                            disabled={!Boolean(storyTitle)}
                            onClick={() => {
                                updateLabel(storyTitle);
                            }}
                        />
                    </S_SidebarContent>
                )}
            </SidebarSection>
        </S_IconMarkerLabelSection>
    );
};

const S_IconMarkerLabelSection = styled.div``;

const S_SidebarContent = styled(SidebarContent)`
    flex-direction: row;
    column-gap: 15px;
`;
